import React from 'react';
import { Container } from 'reactstrap';
import SpotlightGroupListPage from './SpotlightGroupListPage';
import SpotlightShowcase from './components/SpotlightShowcase';

const SpotlightPage = () => {
  return (
    <Container>
      <SpotlightShowcase />
      <SpotlightGroupListPage />
    </Container>
  );
};

export default SpotlightPage;
